import clsx from 'clsx';
import React from 'react';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import TextArea from '../TextArea';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';

interface ApproveAndCloseModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
  requestExtension?: string;
}

const ApproveAndCloseModal: React.FC<ApproveAndCloseModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
  requestExtension,
}) => {
  const approveAndCloseModalClasses = clsx(otherClasses);

  return (
    <div
      className={approveAndCloseModalClasses}
      data-testid="approve-and-close-modal"
    >
      <div className="mb-6 flex w-full flex-col items-center gap-2.5 text-center lg:mb-9">
        {requestExtension === 'request-extension' ||
        requestExtension === 'review-reject' ? (
          <WarningIcon className="[&>path]:fill-brand-papery h-12 w-12 md:h-85 md:w-85" />
        ) : (
          <GreenCheckIcon className="[&>path]:fill-brand-papery h-12 w-12 md:h-85 md:w-85" />
        )}
        <h4
          className={clsx(
            requestExtension === 'request-extension' ||
              requestExtension === 'review-reject'
              ? 'text-brand-posh-pink'
              : 'text-brand-papery',
          )}
        >
          {requestExtension === 'request-extension' ||
          requestExtension === 'review-reject'
            ? `Rejection Cause?`
            : `Approve and Close`}
        </h4>
        <p
          className={clsx(
            'font-inter-variable text-lg leading-5 font-normal',
            requestExtension === 'request-extension' ||
              requestExtension === 'review-reject'
              ? 'text-brand-posh-pink'
              : 'text-brand-papery',
          )}
        >
          {requestExtension === 'request-extension'
            ? `Write the reason below for rejecting the due date extension requested by user.`
            : requestExtension === 'review-reject'
              ? `Write the reason below for rejecting the review request.`
              : `Do you want to approve and close this submission? This action is
          irreversible, and the employee will be notified.`}
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mt-2.5 grid grid-cols-1">
          <TextArea
            name="description"
            onBlur={formHandler?.handleBlur}
            onChange={formHandler?.handleChange}
            value={formHandler?.values?.description}
            placeholder={
              requestExtension === 'request-extension'
                ? `Write something here e.g. cannot be extended due to tough deadline...`
                : requestExtension === 'review-reject'
                  ? `Write something here e.g. The specified action assigned was not looked into properly...`
                  : `Write something here e.g. The assigned corrective was completed successfully...`
            }
            disabled={formHandler?.isSubmitting}
            errorMessage={
              formHandler?.touched.description &&
              formHandler?.errors.description
                ? formHandler?.errors.description
                : ''
            }
            label={
              requestExtension === 'approve-review'
                ? 'Description (optional)'
                : 'Reason*'
            }
            otherClasses={{ container: 'w-full ' }}
          />
        </div>
        <div className="mt-6 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => handleClose()}
            disable={formHandler?.isSubmitting}
            otherClasses={clsx(
              requestExtension === 'request-extension' ||
                requestExtension === 'review-reject'
                ? 'text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink'
                : 'text-brand-papery hover:border-brand-papery hover:text-brand-papery',
            )}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            size={useButtonSizeSmall()}
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            otherClasses={clsx(
              requestExtension === 'request-extension' ||
                requestExtension === 'review-reject'
                ? 'bg-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink'
                : 'bg-brand-papery hover:text-brand-papery hover:border-brand-papery',
            )}
          >
            {requestExtension === 'request-extension' ||
            requestExtension === 'review-reject'
              ? `Reject`
              : `Approve and Close`}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ApproveAndCloseModal;
